module.exports = __webpack_public_path__ + "img/file-text.71a23255.svg";